/* eslint-disable no-unused-vars */

function locationsLandingFilterButton() {
    const button = document.getElementById('storeLocatorFilterButton');
    const dropdownFilter = document.getElementById('storeLocatorServiceFilter');
    if(button && dropdownFilter) {
        button.onclick = function () {
            if(dropdownFilter.value === 'all-services') {
                location.href = "/store-locator";
            } else {
                location.href = "/store-locator?locationService=" + dropdownFilter.value;
            }
        };
    }
};

function setupHeaderLocationButton() {
    const button = document.getElementById('header__locationTarget');
    if(!button) {
        return;
    }
    const locationWidget = document.getElementById('header__locationWidget');

    
    if(button && locationWidget) {
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-haspopup', 'true');
        button.setAttribute('aria-controls', 'header__locationWidget');
        locationWidget.setAttribute('aria-hidden', 'true');
        
        button.onclick = function () {
            locationWidget.classList.toggle('hidden');
            button.setAttribute('aria-expanded', !locationWidget.classList.contains('hidden'));
            locationWidget.setAttribute('aria-hidden', locationWidget.classList.contains('hidden'));
        }
    
        document.addEventListener('click', (event) => {    
            if (!locationWidget.contains(event.target) && event.target !== button) {
                locationWidget.classList.add('hidden');
                button.setAttribute('aria-expanded', !locationWidget.classList.contains('hidden'));
                locationWidget.setAttribute('aria-hidden', locationWidget.classList.contains('hidden'));
            }
        });

        // press escape key to close menu
        document.addEventListener('keyup', (event) => {
            if (event.key === 'Escape') {
                locationWidget.classList.add('hidden');
                button.setAttribute('aria-expanded', !locationWidget.classList.contains('hidden'));
                locationWidget.setAttribute('aria-hidden', locationWidget.classList.contains('hidden'));
            }
        });
    }
}


function formatStoreLocatorResults() {

    const firstCheck = setInterval(() => {
        // const results = document.getElementById('wpsl-stores');
        const images = document.getElementsByClassName('wpsl-store-thumb');
        const locations = document.getElementsByClassName('wpsl-store-location');


        if(images && images.length && locations && locations.length) {

            // Remove thumbnails
            while(images.length) {
                images[0].parentElement.removeChild(images[0]);
            }

            for(let i = 0; i < locations.length; i++) {
                const parentCard = locations[i].parentElement;
                const locationSlug = locations[i].childNodes[0].nextSibling.childNodes[1].innerText.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
                const textContainer = parentCard.getElementsByClassName('wpsl-store-location')[0];

                // Add text cta at bottom of card
                const newCta = document.createElement('span');
                newCta.className = 'wpsl__locationCta';
                newCta.innerText = 'View Location';

                const newIcon = document.createElement('span');
                newIcon.className = 'cardModule__ctaIcon';
                const newArrow = document.createElement('span');
                newArrow.className = 'fa-solid fa-arrow-right';
                newIcon.appendChild(newArrow);
                newCta.appendChild(newIcon);
                textContainer.appendChild(newCta);

                // Edit text on location cards
                const allText = textContainer.childNodes[1].getElementsByTagName('span');
                let newText = '';
                for(let j = 0; j < allText.length - 1; j++) {
                    newText += allText[j].innerText;
                    if(j !== allText.length - 2) {
                        newText += ', ';
                    }
                }
                allText[0].innerText = newText;
                textContainer.childNodes[1].removeChild(allText[2]);
                textContainer.childNodes[1].removeChild(allText[1]);


                // Add link to card
                const newLink = document.createElement('a');
                newLink.href = '/locations/' + locationSlug;
                newLink.className = 'wpsl-store-link';
                parentCard.appendChild(newLink);

                // Add image to card
                const newImage = document.createElement('img');
                const imageContainer = document.createElement('div');
                imageContainer.className = 'storeLocator__locationImage';
                getFeaturedImageUrl(parentCard.dataset.storeId).then((imageUrl) => {
                    newImage.src = imageUrl;

                    if(imageUrl) {
                        imageContainer.appendChild(newImage);
                        parentCard.insertBefore(imageContainer, parentCard.childNodes[0])
                    }
                });

                
            }

        }

    }, 100);

    const secondCheck = setInterval(() => {
        // Adjust link in map info popovers
        const popovers = document.getElementsByClassName('wpsl-info-window');
        if(popovers && popovers.length) {
            for(let i = 0; i < popovers.length; i++) {
                const slug = popovers[i].getElementsByTagName('strong')[0].innerText.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
                const link = popovers[i].getElementsByClassName('wpsl-directions')[0];
                if(link) {
                    const newLink = document.createElement('a');
                    newLink.href = '/locations/' + slug;
                    newLink.innerText = 'View Location';
                    link.parentElement.insertBefore(newLink, link);
                    link.parentElement.removeChild(link);
                }
            }
        }
    }, 20);
}

async function getFeaturedImageUrl(locationId) {
    const response = await fetch('/wp-json/wp/v2/wpsl_stores/' + locationId + '?_embed', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const myJson = await response.json();

      if(myJson && myJson._embedded && myJson._embedded['wp:featuredmedia']) {
          return myJson._embedded['wp:featuredmedia']['0'].source_url;
      }

      return null;
}

function locationsLandingMobileFilters() {
    const button = document.getElementById('blogLanding__mobileFiltersTarget');
    const mobileFilters = document.getElementById('blogLanding__mobileFiltersList');

    if(button && mobileFilters) {
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-haspopup', 'true');
        button.setAttribute('aria-controls', 'blogLanding__mobileFiltersList');
        mobileFilters.setAttribute('aria-hidden', 'true');

        button.onclick = function () {
            mobileFilters.classList.toggle('hidden');
            button.classList.toggle('open');
            button.setAttribute('aria-expanded', !mobileFilters.classList.contains('hidden'));
            mobileFilters.setAttribute('aria-hidden', mobileFilters.classList.contains('hidden'));
        }
    
        document.addEventListener('click', (event) => {    
            if (!mobileFilters.contains(event.target) && event.target !== button) {
                mobileFilters.classList.add('hidden');
                button.classList.remove('open');
                button.setAttribute('aria-expanded', !mobileFilters.classList.contains('hidden'));
                mobileFilters.setAttribute('aria-hidden', mobileFilters.classList.contains('hidden'));
            }
        });
    }
}

/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    locationsLandingFilterButton();
    setupHeaderLocationButton();
    formatStoreLocatorResults();
    locationsLandingMobileFilters();
};

export default init;
